(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-fxl-navigation]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const header = root.closest('.fxl-header-wrapper');
      const nav = root.querySelector('.fxl-nav');
      const dropdowns = [...root.querySelectorAll('.fxl-nav__details')];
      const dialog = root.querySelector('[data-fxl-nav-dialog]');
      const openers = [...header.querySelectorAll('[data-fxl-nav-open]')];
      const levels = [...dialog.querySelectorAll('[data-fxl-nav-level]')];
      const wide = matchMedia('(min-width: 1101px)');
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      const controller = new AbortController();
      const signal = controller.signal;
      const on = (el, event, handler) => el.addEventListener(event, handler, { signal });
      let openTimer;
      let closeTimer;
      let focusTimer;
      let returnFocus;
      let previousOverflow;
      const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); clearTimeout(focusTimer); };
      const setExpanded = item => item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
      const closeDropdowns = except => {
        dropdowns.forEach(item => {
          if (item !== except) { item.open = false; setExpanded(item); }
        });
      };
      const sizePanel = () => nav.style.setProperty('--fxl-nav-available', `${Math.max(120, innerHeight - nav.getBoundingClientRect().bottom - 16)}px`);
      dropdowns.forEach(item => {
        const summary = item.querySelector('summary');
        on(item, 'toggle', () => {
          setExpanded(item);
          if (item.open) { closeDropdowns(item); sizePanel(); }
        });
        on(item, 'pointerenter', () => {
          if (!wide.matches || !hover.matches) return;
          clearTimers();
          openTimer = setTimeout(() => { closeDropdowns(item); sizePanel(); item.open = true; setExpanded(item); }, 130);
        });
        on(item, 'pointerleave', () => {
          if (!wide.matches || !hover.matches) return;
          clearTimers();
          if (!item.contains(document.activeElement)) closeTimer = setTimeout(() => { item.open = false; setExpanded(item); }, 220);
        });
        on(item, 'focusout', event => {
          clearTimeout(focusTimer);
          if (!event.relatedTarget || item.contains(event.relatedTarget)) return;
          focusTimer = setTimeout(() => {
            if (!signal.aborted && item.open && !item.contains(document.activeElement)) {
              item.open = false;
              setExpanded(item);
            }
          }, 0);
        });
        on(summary, 'keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault(); clearTimers(); closeDropdowns(item); item.open = true; setExpanded(item); sizePanel();
            item.querySelector('.fxl-nav__panel a')?.focus();
          }
        });
      });
      const showLevel = (id, back = false) => {
        const target = levels.find(level => level.id === id);
        if (!target) return;
        const previous = levels.find(level => !level.hidden);
        levels.forEach(level => { level.hidden = level !== target; });
        dialog.querySelectorAll('[data-fxl-nav-next]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.fxlNavNext === id)));
        dialog.querySelector('.fxl-nav-drawer__body').scrollTop = 0;
        const priorButton = back && [...target.querySelectorAll('[data-fxl-nav-next]')].find(button => button.dataset.fxlNavNext === previous?.id);
        (priorButton || target.querySelector('h2')).focus({ preventScroll: true });
      };
      openers.forEach(button => on(button, 'click', () => {
        clearTimers(); closeDropdowns(); returnFocus = button;
        levels.forEach((level, index) => { level.hidden = index !== 0; });
        dialog.querySelectorAll('[data-fxl-nav-next]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        if (!dialog.open) {
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        openers.forEach(opener => opener.setAttribute('aria-expanded', 'true'));
        dialog.querySelector('[data-fxl-nav-close]').focus();
      }));
      on(dialog, 'click', event => {
        const next = event.target.closest('[data-fxl-nav-next]');
        const back = event.target.closest('[data-fxl-nav-back]');
        if (next) showLevel(next.dataset.fxlNavNext);
        else if (back) showLevel(back.dataset.fxlNavBack, true);
        else if (event.target.closest('[data-fxl-nav-close]')) dialog.close();
        else if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      });
      on(dialog, 'close', () => {
        document.body.style.overflow = previousOverflow || '';
        openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
        if (returnFocus?.isConnected && returnFocus.getClientRects().length) returnFocus.focus({ preventScroll: true });
      });
      on(document, 'pointerdown', event => { if (!nav.contains(event.target)) { clearTimers(); closeDropdowns(); } });
      on(document, 'keydown', event => {
        if (event.key !== 'Escape' || dialog.open) return;
        const current = dropdowns.find(item => item.open);
        if (current) { event.preventDefault(); clearTimers(); closeDropdowns(); current.querySelector('summary').focus(); }
      });
      on(window, 'resize', () => { sizePanel(); if (wide.matches && dialog.open) dialog.close(); });
      on(document, 'shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        if (dialog.open) dialog.close();
        clearTimers(); controller.abort();
      });
    });
  };
  if (window.fxlNavigationInitialized) return;
  window.fxlNavigationInitialized = true;
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

